import { render, staticRenderFns } from "./StudyStatistics.vue?vue&type=template&id=292c6334&scoped=true&"
import script from "./StudyStatistics.vue?vue&type=script&lang=js&"
export * from "./StudyStatistics.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/project-detail.css?vue&type=style&index=0&id=292c6334&scoped=true&lang=css&"
import style1 from "./StudyStatistics.vue?vue&type=style&index=1&id=292c6334&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "292c6334",
  null
  
)

export default component.exports